import { Fab } from '@/components/elements/forms/buttons';
import Icon from '@/components/icons/Icon';
import { isMobile, scrollAccordionContentInView, startOfDay } from '@/helpers';
import { _s } from '@/locale';
import { _t } from '@/locale/i18n';
import { Place, PlaceBundle } from '@/types/state/shared';
import { Fragment, useState } from 'react';
import Bundle from './Bundle';

type PlaceWithBundles = Place & { bookingBundles?: PlaceBundle & { highlightedName?: React.ReactNode | null }[] };

type BundlesProps = {
  place: PlaceWithBundles | Place;
  isOpen?: boolean;
  date?: number;
  source?: string;
  title?: string;
};

const baseTranslationKey = 'components.modules.salon.Bundles';

const Bundles = ({ place, isOpen, date, title }: BundlesProps) => {
  const [expanded, setExpanded] = useState(!!(isOpen ?? true));
  const collapseClass = expanded ? 'block' : 'hidden';

  if (!place?.bookingBundles?.length) {
    return null;
  }

  if (!date) {
    date = startOfDay();
  }

  const handleCollapse = (e) => {
    const newExpanded = !expanded;
    if (expanded) {
      setExpanded(newExpanded);
      scrollAccordionContentInView(e.target);
    } else {
      setExpanded(newExpanded);
    }
  };

  const bundles = place.bookingBundles.map((item) => (
    <Fragment key={item.id}>
      <Bundle bundle={item} place={place} />
    </Fragment>
  ));

  return (
    <div className="relative">
      <div className={`item  ${expanded && !isMobile() ? 'mb-4' : ''}`}>
        <div
          onClick={handleCollapse}
          className="py-md border-border_regular flex w-full items-center justify-between border-t outline-none">
          <h2 className="text-h-s">{title ?? _t('buyBundles.bundles')}</h2>
          <span className="ml-xs relative flex flex-1">
            <Icon variant="punch-card-filled" color="fg_notice" />
          </span>
          <div className="gap-sm text-fg_secondary flex items-center">
            <span>{bundles?.length}</span>
            <Fab
              size="sm"
              variant="secondary"
              aria-label={_s(`${baseTranslationKey}.ariaLabel.${expanded ? 'close' : 'open'}`)}
              onClick={handleCollapse}
              rightIcon={<Icon variant={expanded ? 'chevron-up' : 'chevron-down'} color="fg_primary" />}
            />
          </div>
        </div>
        <div className={'accordion-content ' + collapseClass} role="tabpanel">
          <ul className={`gap-sm flex flex-col`}>{bundles}</ul>
        </div>
      </div>
    </div>
  );
};

export default Bundles;
